export default __webpack_public_path__ + "static/media/banquet.53267eef.png";